import {
  showSettings as showSettingsApi
} from './api'

let showSettings = () => dispatch => {
  return showSettingsApi()
}

export { showSettings }
